import { GrowthBook } from "@growthbook/growthbook-react";
import { getTracking, setTracking } from "@website/store/tracking";
import { isChannel } from "@website/utils/channel/helpers";
import { isSSR } from "@website/utils/is-ssr";
import keyBy from "lodash-es/keyBy";
import mapValues from "lodash-es/mapValues";

let growthbook: GrowthBook;

export const GenerateGrowthBookInstance = () => {
  if (isSSR()) return;
  growthbook = new GrowthBook({
    enabled: isChannel(["web", "website", "jek"]),
    apiHost: process.env.NEXT_PUBLIC_BASE_URL_GPI,
    clientKey: "sdk-Z2itvy5yPKT5xu",
    enableDevMode: false,
    subscribeToChanges: true
    // trackingCallback: (experiment, result) => {
    //   // TODO: Use your real analytics tracking system
    //   // console.log("Viewed Experiment", {
    //   //   experimentId: experiment.key,
    //   //   variationId: result.key
    //   // });
    // }
  });

  growthbook
    .init({ streaming: true })
    // eslint-disable-next-line unicorn/prefer-top-level-await
    .finally(() => {
      setTracking((previous) => ({
        ...previous,
        experiment: {
          experiment_group_hotel: chanceBetween([20, 30, 50]),
          experiment_hotel_cta:
            isChannel(["jek", "website", "android", "snapp-ir"]) &&
            Math.random() < 0.25,
          experiment_villa_pricing:
            isChannel(["jek", "website", "android", "snapp-ir"]) &&
            Math.random() < 0.5,
          experiment_villa_without_date:
            isChannel(["jek", "website", "android", "snapp-ir"]) &&
            Math.random() < 0.5,
          experiment_villa_page_new_design:
            isChannel(["jek", "website", "android", "snapp-ir"]) &&
            Math.random() < 0.8,

          dynamic_pricing: Math.random() < 0.5 ? "1" : "2",
          experiment_step_by_step_search:
            isChannel(["jek", "website", "android", "snapp-ir"]) &&
            Math.random() < 0.5,
          experiment_snapppay_modal: Math.random() < 0.5 ? "true" : "false",
          experiment_new_tour_design: isChannel(["telesale"])
            ? "true"
            : Math.random() < 0.5
              ? "true"
              : "false",
          ...previous.experiment,
          ...getAllExperiments()
        }
      }));
    });

  growthbook.setAttributes({
    id: getTracking().aid
  });
};

const getAllExperiments = () =>
  mapValues(
    keyBy([...(growthbook?.getAllResults().values() ?? [])], "experiment.key"),
    "result.inExperiment"
  );

const chanceBetween = (chances: Array<number>) => {
  const sorted = chances.sort((a, b) => a - b);
  return (
    sorted.find((chance) => chance >= Math.random() * 100) ||
    (sorted.at(-1) as number)
  );
};
